<template>
  <transaction-list
    :product="product"
    :transactionService = transactionService
    :productService = productService
    :locationService = locationService
    :showCost = showCost
  ></transaction-list>
</template>
<script>
  import TransactionList from '@/components/Common/Transaction/TransactionList'
  import {mapGetters} from 'vuex'

  export default {
    components: {
      TransactionList
    },
    props: {
      product: Object,
      show: Boolean,
      productService: Object,
      transactionService: Object,
      locationService: Object,
    },

    computed: {
      ...mapGetters('acl', [
        'matchRoles'
      ]),

      showCost () {
        return this.matchRoles(['machine_operation'])
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/Common/Rental/Products/Transaction.vue